import React from 'react';
import PropTypes from 'prop-types';

import Message from '../../Message';

export const OptionsComponent = ({
  options,
  noOptionsMessage,
  onSelect,
}) => {
  if (!options.length) {
    return (
      <div className="c-dropdown__no-options-content">
        <Message message={noOptionsMessage} />
      </div>
    );
  }

  return (
    <>
      {options.map((option, index) => (
        <div
          data-testid={`option-${option.value}`}
          key={`option-${option.value}`}
          tabIndex={index + 1}
          className="c-dropdown__option"
          onClick={() => onSelect(option)}
        >
          {option.label || option.value}
        </div>
      ))}
    </>
  );
};

OptionsComponent.propTypes = {
  options: PropTypes.array.isRequired,
  noOptionsMessage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default OptionsComponent;
